import React from "react";
import {
  FaBuilding,
  FaHospital,
  FaUniversity,
  FaIndustry,
  FaShoppingBag,
  FaChartLine,
  FaUsers,
} from "react-icons/fa";

export default function IndustriesSection() {
  const industries = [
    {
      icon: <FaBuilding />,
      title: "Real Estate",
      desc: "Project finance, taxation, and compliance for large developments.",
    },
    {
      icon: <FaHospital />,
      title: "Healthcare",
      desc: "Financial governance and compliance for hospitals and medical enterprises.",
    },
    {
      icon: <FaUniversity />,
      title: "Education",
      desc: "Transparent accounting and regulatory assurance for institutions and trusts.",
    },
    {
      icon: <FaIndustry />,
      title: "Manufacturing",
      desc: "Cost control, working capital, and compliance for industrial operations.",
    },
    {
      icon: <FaShoppingBag />,
      title: "Retail",
      desc: "Scalable financial systems and GST compliance for growing businesses.",
    },
    {
      icon: <FaChartLine />,
      title: "Finance",
      desc: "Strategic finance, governance, and transaction support for growth.",
    },
    {
      icon: <FaUsers />,
      title: "Capital Market Brokers",
      desc: "Audit, taxation, and regulatory services for brokers and market participants.",
    },
  ];

  return (
    <section className="industries-area">
      <div className="industries-overlay"></div>
      <div className="container text-center position-relative">
        <h2 className="section-title text-white">Industries We Serve</h2>
        <p className="section-subtitle text-light">
          Empowering diverse sectors with tailored financial & business solutions.
        </p>

        {/* Row 1: 4 cards */}
        <div className="row justify-content-center mb-4">
          {industries.slice(0, 4).map((item, index) => (
            <div key={index} className="col-md-3 col-sm-6 mb-4">
              <div className="industry-card">
                <div className="icon-box">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Row 2: 3 cards centered */}
        <div className="row justify-content-center">
          {industries.slice(4).map((item, index) => (
            <div key={index} className="col-md-3 col-sm-6 mb-4">
              <div className="industry-card">
                <div className="icon-box">{item.icon}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
